module.exports = __webpack_public_path__ + "img/RTrireme64_ua.79dd24d4.webp";